export default "__VITE_ASSET__CxKyNz$Z__"